export const subscriptionsLayoutData = {
  title: 'subscriptionTitle',
  description: 'subscriptionDescription',
}

export const cacheExclusionRegExpList = [
  /deviceflowsessions/,
  /accessrights/,
  /promotions/,
  /regionInfo/,
  /creditWallets/,
  /cryptoWallet/,
  /claims/,
  /claim/,
  /unique/,
  /claimTasks/,
  /fixtures/,
  /standings/,
]

export enum appSettingsIds {
  isCustomPaletteUsed = 'isCustomPaletteUsed',
  isDevToolsUsed = 'isDevToolsUsed',
  isPerformanceMonitorUsed = 'isPerformanceMonitorUsed',
  isDisabledBlur = 'isDisabledBlur',
  isDisabledImages = 'isDisabledImages',
  isDisabledHtmlWidgets = 'isDisabledHtmlWidgets',
  isDisabledLines = 'isDisabledLines',
  isFullscreenAutoLandscapeUsed = 'isFullscreenAutoLandscapeUsed',
  isEnabledAdSettingsOverride = 'isEnabledAdSettingsOverride',
  isEnabledImaSdk = 'isEnabledImaSdk',
  isEnabledImaSdkDebug = 'isEnabledImaSdkDebug',
  isAlwaysGoToDetailPage = 'isAlwaysGoToDetailPage',
  isDisabledStageAutoslide = 'isDisabledStageAutoslide',
  isEnabledChannelEventMockData = 'isEnabledChannelEventMockData',
}
